<template>
  <el-form :inline="true" class="demo-form-inline" :label-position="labelPosition" ref="myForm">
    <el-form-item label="Type">
      <el-select v-model="type" placeholder="Please select type" style="width:200px;">
      <el-option v-for="option in typeOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Species">
      <el-select v-model="species" placeholder="Please select species" style="width:200px;" @change="handleSpeciesChange">
      <el-option v-for="option in speciesOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Tissue">
      <el-select v-model="tissue" placeholder="Please select tissue" style="width:200px;">
        <el-option v-for="option in tissueOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button class="search-button" size="small" type="primary" @click="handleSearch" style="width:200px;">search</el-button>
    </el-form-item>
    <el-form-item>
      <el-button class="search-button" size="small" type="primary" @click="resetForm" style="width:200px;">reset</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: 'top',
      type: 'Individual-Enhancer',
      species: 'human', // 初始设置为 'mouse'
      tissue: '',
      typeOptions: [
        { label: 'Typical-Enhancer', value: 'Typical-Enhancer' },
        { label: 'Super-Enhancer', value: 'Super-Enhancer' },
        { label: 'Core-Enhancer', value: 'Individual-Enhancer' },
      ],
      speciesOptions: [
        { label: 'human', value: 'human' },
        { label: 'mouse', value: 'mouse' },
      ],
      tissueOptions: [],
    };
  },
  created() {
    // 在页面创建时，根据初始的物种值动态设置组织选项
    this.handleSpeciesChange();
  },
  methods: {
    handleSearch() {
      if (!this.species || !this.tissue || !this.type) {
        this.$message.error('Please complete the input field.');
        return;
      }
      const params = {
        Type: this.type,
        Species: this.species,
        Tissue: this.tissue,
      };
      this.$emit('search', params);
    },
    resetForm() {
      this.type = '';
      this.species = ''; // 重置物种为 'mouse'
      this.tissue = '';
      // 重置物种后再次触发组织选项更新
      this.handleSpeciesChange();
    },
    handleSpeciesChange() {
      const params = { Species: this.species, };
      this.$axios.get('http://183.175.59.4/devenhancer/searchname/', {
        params: params,
      })
      .then(response => {
        // 处理后端返回的数据
        this.tissueOptions = response.data.map(item => ({
          label: item.Tissue,
          value: item.Tissue,
        }));
        // 设置默认值
        if (this.species === 'human') {
          this.tissue = 'DE';
        } else if (this.species === 'mouse') {
          this.tissue = 'PS';
        }
      })
      .catch(error => {
        console.error(error);
        this.$message.error('Failed to fetch tissue data.');
      });
    },
  },
};
</script>

<style scoped>
.demo-form-inline {
  font-weight: bold;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 30px;
}
.search-button {
  color: #F1F7E7;
  font-size: medium;
  float: left;
  background-color: #2C3E50;
  width: 100px;
  border: 1px solid #2C3E50; /* 设置边框为与背景色一致 */
}
</style>


// WEBPACK FOOTER //
// src/components/Feature/Featureselect.vue